import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { isAttachmentElement } from '../../../types/guards';
import MediaCommon from '../MediaCommon';

// Download an attachment.
class ToolDownload extends Tool {
  static toolName = 'Download';
  static iconClass = 'far fa-download';

  static action({ element, editor, controller }: ToolArgsWithController): void {
    if (!element || !isAttachmentElement(element)) return;

    // Programmatically download.
    const link = document.createElement('a');
    link.href = element.media_src;
    link.download = element.attachment_fileName || 'attachment';
    link.click();
  }

  static isEnabled({ element }: ToolArgsWithController): boolean {
    if (!element || !isAttachmentElement(element)) return false;

    return !MediaCommon.isTemporaryDataUrl(element.media_src);
  }
}

export default ToolDownload;
